import { render } from "./TeamBotChat.vue?vue&type=template&id=599b0480&scoped=true"
import script from "./TeamBotChat.vue?vue&type=script&lang=js"
export * from "./TeamBotChat.vue?vue&type=script&lang=js"

import "./TeamBotChat.vue?vue&type=style&index=0&id=599b0480&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599b0480"]])

export default __exports__